// Max characters allowed between two consecutive matched characters.
const MAX_GAP = 4;

// In-order subsequence match with a gap limit (e.g. "blogna", "emirom").
const subsequence = (s: string, hay: string, maxGap: number): boolean => {
  let i = 0;
  let n = -1;
  let l: string | undefined;
  // biome-ignore lint/suspicious/noAssignInExpressions: ignora
  while ((l = s[i++])) {
    const next = hay.indexOf(l, n + 1);
    if (next < 0) return false;
    if (n >= 0 && next - n - 1 > maxGap) return false;
    n = next;
  }
  return true;
};

const fuzzy = (string: string, word: string, maxGap = MAX_GAP): boolean => {
  const s = string.toLowerCase();
  const hay = word.toLowerCase();
  return subsequence(s, hay, maxGap);
};

fuzzy.multiple = (string: string, words: string[], maxGap = MAX_GAP) => {
  return words.some((word) => fuzzy(string, word, maxGap));
};

export default fuzzy;
